module.exports = __webpack_public_path__ + "img/5.13be9d42.jpg";